import { FormControlLabel, Grid, IconButton, MenuItem, Switch, Tooltip } from '@mui/material';
import { HelpOutline, Save } from '@mui/icons-material';
// import Breadcrumbs from 'components/Breadcrumbs';
import PageTittle from 'components/PageTittle';
import FormGrid from 'components/FormGrid';
import Button from 'components/Button';
import { useMatches, useParams } from 'react-router-dom';
import { getPermissions } from 'utils/userUtils';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import Dropdown from 'components/Dropdown';

function FormLayout({ children, form, hideDisableSwitch, onSave, titleExtra, helpURL }){
  const { t } = useTranslation('Actions');

  const params = useParams();
  const matches = useMatches();

  const { control, getValues } = form;

  const routePermission = matches
    .find((match) => Boolean(match.handle?.permission))
    ?.handle?.permission;

  const permissions = getPermissions(routePermission);

  const userHasPermission = routePermission
    ? params?.guid
        ? permissions.update
        : permissions.include
    : true

  return(
    <>
      {/* <Grid container>
        <Grid item xs={12}>
          <Breadcrumbs/>
        </Grid>
      </Grid> */}
      <Grid container columnSpacing={3} py={2} sx={{ position: 'sticky', top: '48px', backgroundColor: '#f8f8fa', zIndex: 9 }}>
        <Grid item container md={6} xl={5} alignItems='center'>
          <PageTittle/>
          {(helpURL && typeof helpURL !== 'object') &&
            <IconButton onClick={() => window.open(helpURL, '_blank').focus()} sx={{ marginX: 1 }}>
              <HelpOutline/>
            </IconButton>
          }
          {(helpURL && typeof helpURL === 'object') &&
            <Dropdown
              anchor={
                <IconButton sx={{ marginX: 1 }}>
                  <HelpOutline/>
                </IconButton>
              }
            >
              {helpURL.map(el => 
                <MenuItem onClick={() => window.open(el.url, '_blank').focus()}>
                  {t(el.label)}
                </MenuItem>
              )}
            </Dropdown>
          }
          <Grid container item lg={6}>
            {titleExtra && 
              titleExtra
            }
          </Grid>
        </Grid>
        <Grid columnSpacing={3} container item md={6} xl={5} justifyContent='right'>
          {(!hideDisableSwitch && userHasPermission && (getValues('SITUACAO') !== undefined)) &&
            <Grid item>
              <Controller
                name='SITUACAO'
                control={control}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    label='Ativo'
                    labelPlacement='end'
                    control={<Switch checked={Boolean(value)}/>}
                    onChange={onChange}
                  />
                )}
              />
            </Grid>
          }
          {onSave &&
            <Grid item>
              <Tooltip title={!userHasPermission ? t('Você não tem permissão para editar esse item.') : null}>
                <span>
                  <Button
                    id='save'
                    startIcon={<Save/>}
                    variant='contained'
                    onClick={onSave}
                    disabled={!userHasPermission}
                    >
                      {t('Salvar')}
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          }
        </Grid>
      </Grid>
      <FormGrid>
        {children}
        <Button type='submit' style={{ display: 'none' }}/>
      </FormGrid>
    </>
  )
} export default FormLayout;